import { gql, useQuery } from '@apollo/client';
import { currentPermissionsVar, isWaitingUserVar } from 'api/cache';
import { SCREEN_PERMISSIONS, USER_STATUS_KEY } from 'appConstants';
import { validateEmail } from 'utils/other';

export const GET_CURRENT_USER = gql`
  query UserDetail {
    detail {
      id
      name
      email
      status
      statusName
      userType
      userTypeName
      image
      channels
      userFeatureChannels {
        userId
        featureId
        channels
      }
      host {
        id
        name
        image
        dateOfBirth
        introduction
        education
        experience
        currentWorkingPlace
      }
    }
  }
`;

export const GET_LOGGIN_LOG = gql`
  query LoginAttemptByUserId($id: String!) {
    loginAttemptByUserId(id: $id) {
      id
      userId
      ip
      userAgent
      success
      createdDate
      user {
        id
        name
        email
        status
      }
    }
  }
`;

export const useCurrentUser = () => {
  const { client, data, error, loading } = useQuery(GET_CURRENT_USER, {
    onCompleted: ({ detail: { userType, email, statusName } }) => {
      const isOldUser =
        !validateEmail(email) && statusName === USER_STATUS_KEY.WAITING;
      isWaitingUserVar(isOldUser);
      const currentPermissions = SCREEN_PERMISSIONS[userType];
      // --- DEBUG START ---
      console.log('--- DEBUG: queryCurrentUser.js ---');
      console.log('userType:', userType);
      console.log('SCREEN_PERMISSIONS:', SCREEN_PERMISSIONS);
      console.log('currentPermissions:', currentPermissions);
      // --- DEBUG END ---
      currentPermissionsVar(currentPermissions);
    }
  });
  return { client, data, error, loading };
};
